/* eslint-disable */
export default {
  removeMeetingWarning:
    'スケジュール機能は廃止されました。ビデオ会議をスケジュールするには、{app}を使用してください。',
  scheduleMeetingTips:
    'このアプリから会議を削除しました。会議を使用するには、{app}の使用をお勧めします。',
  migrateToPluginAlert:
    '注意：このアプリは、Outlook 2016以前のバージョンおよびInternet Explorer 11では動作しません。Outlookをアップグレードするか、Microsoft Edgeに切り替えるか、あるいは{app}に切り替えてください。',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
